import store from '@/store'
export default async function externalComponent(route, name) {
  if (window[name]) return window[name];

  const baseUrl = `${store.getters["account/apiUrl"]}/api`
  const url = `${baseUrl}/${route}?access_token=${store.getters["account/token"]}`

  window[name] = await new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.async = true;
    script.addEventListener('load', () => {
      resolve(window[name]);
    });
    script.addEventListener('error', () => {
      reject(new Error(`Error loading ${url}`));
    });
    script.src = url;
    document.head.appendChild(script);
  });

  return window[name];
}